/**
 * NOVA-038 — the export download control. Three format buttons (JSON / CSV / XLSX); each fires the audited
 * GET /analytics/export then renders + downloads that format client-side. Shown only when the actor holds
 * analytics.tableau.view (the server re-checks + band-scopes the export rows — this only gates the UI).
 * The download is aggregate-only by contract (no per-patient line ever leaves the server).
 */
import { Button } from "@/ui";
import { useT } from "@/app";
import { useExportDownload } from "../api";
import type { ExportFormat } from "../types";

const FORMATS: ReadonlyArray<ExportFormat> = ["json", "csv", "xlsx"];

export function ExportMenu() {
  const { t } = useT();
  const download = useExportDownload();
  const pending = download.isPending;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "var(--nv-s-2)" }}>
      <span style={{ fontSize: "var(--nv-fs-caption)", color: "var(--nv-steel)" }}>
        {t("analytics.export.label")}
      </span>
      {FORMATS.map((fmt) => (
        <Button
          key={fmt}
          variant="secondary"
          size="sm"
          disabled={pending}
          onClick={() => download.mutate(fmt)}
          aria-label={t("analytics.export.aria", { format: fmt.toUpperCase() })}
        >
          {t(`analytics.export.${fmt}`)}
        </Button>
      ))}
      {download.isError && (
        <span role="alert" style={{ fontSize: "var(--nv-fs-caption)", color: "var(--nv-danger)" }}>
          {t("analytics.export.error")}
        </span>
      )}
    </div>
  );
}
